import { useCallback, useMemo } from 'react';
import { create } from 'zustand';
export const useDocumentSelectionStore = create()((set, get) => ({
    documentIds: [],
    addDocumentsIds: ({ documentIds: ids }) => {
        const state = get();
        const documentIds = [...new Set([...state.documentIds, ...ids])];
        set({ documentIds });
    },
    setDocumentsIds: ({ documentIds }) => {
        set({ documentIds });
    },
    clearDocumentsIds: () => set({ documentIds: [] }),
    toggleDocumentSelection: ({ documentIds: ids }) => {
        const state = get();
        const documentIds = ids.reduce((acc, curr) => {
            if (state.documentIds.includes(curr)) {
                return acc.filter(id => id !== curr);
            }
            return [...acc, curr];
        }, state.documentIds);
        set({ documentIds });
    },
    isSelected: ({ documentId }) => {
        const state = get();
        return state.documentIds.includes(documentId);
    },
}));
export const useDocumentSelection = () => {
    const { documentIds, setDocumentsIds, clearDocumentsIds, toggleDocumentSelection } = useDocumentSelectionStore();
    const selectedDocuments = useMemo(() => documentIds.reduce((acc, curr) => ({ ...acc, [curr]: true }), {}), [documentIds]);
    const handleDocumentSelection = useCallback((selection) => {
        setDocumentsIds({ documentIds: typeof selection === 'string' ? [selection] : Object.keys(selection) });
    }, [setDocumentsIds]);
    const isSelected = useCallback((id) => documentIds.includes(id), [documentIds]);
    return {
        activeDocumentId: documentIds[0],
        selectedDocuments,
        selectedDocumentIds: documentIds,
        hasMultipleSelected: documentIds.length > 1,
        numberOfDocumentsSelected: documentIds.length,
        toggleDocumentSelection,
        setDocumentsIds,
        handleDocumentSelection,
        clearDocumentSelection: clearDocumentsIds,
        isSelected,
    };
};
